import type React from 'react';
import Button from '../button';

/**
 * Props for the shared toggle button primitive.
 */
export interface ToggleButtonProps
  extends React.ComponentProps<typeof Button> {
  /** Whether the toggle is currently pressed. */
  pressed: boolean;
  /** Called with the next pressed state when the button is clicked. */
  onPressedChange: (pressed: boolean) => void;
}

/**
 * Shared button primitive for boolean pressed/unpressed actions.
 */
export const ToggleButton = ({
  pressed,
  onPressedChange,
  variant = 'primary',
  appearance,
  type = 'button',
  onClick,
  ...props
}: ToggleButtonProps) => {
  const togglePressed = () => onPressedChange(!pressed);

  return (
    <Button
      type={type}
      aria-pressed={pressed}
      variant={variant}
      appearance={appearance ?? (pressed ? 'filled' : 'soft')}
      onClick={(event) => {
        onClick?.(event);

        if (event.defaultPrevented) {
          return;
        }

        togglePressed();
      }}
      {...props}
    />
  );
};
